const config = require("./config");
const serialize = require("locutus/php/var/serialize");
import AbstractForm from "./AbstractForm";
class SubscribeForm extends AbstractForm {
  constructor(element) {
    super(element);
  }
  getFormData() {
    let data = {
      action: "subscribe",
      params: [{
        responseType: "plain",
        lang: this.pageLang,
        client_domain: this.websiteDomain,
        url: [location.protocol, "//", location.host, location.pathname].join(""),
        email: ""
      }]
    };
    let email = this.element.querySelector('[name="Email"]').value.trim();
    data.params[0].email = email;
    if (this.element.querySelector('[name="Company"]')) {
      data.params[0].company = this.element.querySelector('[name="Company"]').value.trim();
    }
    if (this.element.querySelector('[name="privacyPolicy"]')) {
      let checked = this.element.querySelector('[name="privacyPolicy"]').checked;
      data.params[0].privacyPolicy = checked;
    }
    if (this.element.querySelector('[name="Birthdate"]')) {
      data.params[0].birthdate = this.element.querySelector('[name="Birthdate"]').value.trim();
    }
    if (this.element.querySelector('[name="Title"]')) {
      data.params[0].title = this.element.querySelector('[name="Title"]').value.trim();
    }

    // if this field exists
    if (this.element.querySelector('[name="Gender"]')) {
      // find checked gender
      let checked = this.element.querySelector('[name="Gender"]:checked');
      if (checked) {
        data.params[0].sex = checked.val();
      } else {
        data.params[0].sex = null;
      }
    }
    if (this.element.querySelector('[name="Name"]')) {
      data.params[0].name = this.element.querySelector('[name="Name"]').value.trim();
    }
    return {
      data: {
        data: serialize(data)
      },
      rawData: data
    };
  }
  sendAction() {
    return new Promise((resolve, reject) => {
      this.removerErrorMessages("Email");
      this.removerErrorMessages("Name");
      this.removerErrorMessages("Gender");
      this.removerErrorMessages("Company");
      this.removerErrorMessages("Title");
      this.removerErrorMessages("Birthdate");
      let data = this.getFormData();
      let valid = this.validateAllData(data.rawData.params[0]);
      if (valid === false) {
        resolve(false);
        return;
      }
      this.clearAllErrors();
      this.postData(config.getNewsletterBrandedUrl(), data.data).then(data => {
        resolve({
          data
        });
      }).catch(e => {
        reject({
          e
        });
      });
    });
  }
}
export default SubscribeForm;